import * as ActionType from '../constants/constant_action_types';



export function openItemLocationModal() {
  return { type: ActionType.OPEN_ITEM_LOCATION_MODAL };
}

export function closeItemLocationModal() {
  return { type: ActionType.CLOSE_ITEM_LOCATION_MODAL };
}

export function setItemLocation(data) {
  return { type: ActionType.SET_ITEM_LOCATION, data };
}

export function clearItemLocation() {
  return { type: ActionType.CLEAR_ITEM_LOCATION };
}

export function viewItemLocation() {
  return { type: ActionType.VIEW_ITEM_LOCATION_MODAL };
}

export function editItemLocation() {
  return { type: ActionType.EDIT_ITEM_LOCATION_MODAL };
}

export function saveItemLocation(data) {
  return { type: ActionType.SAVE_ITEM_LOCATION, data };
}

export function applyToAllItemLocation(id, item_id) {
  return { type: ActionType.APPLY_TO_ALL_ITEM_LOCATION, id, item_id };
}

export function deleteItemLocation(data) {
  return { type: ActionType.DELETE_ITEM_LOCATION, data };
}

export function getItemLocations(filters) {
  return { type: ActionType.GET_ITEM_LOCATIONS, filters };
}

export function getItemLocation(id) {
  return { type: ActionType.GET_ITEM_LOCATION, id };
}

export function setItemLocationPagination( page, perPage, totalRows ){
  return { type: ActionType.SET_ITEM_LOCATIONS_PAGINATION, page, perPage, totalRows };
}

export function initializeDefaultItemLocation( data ){
  return { type: ActionType.INITIALIZE_DEFAULT_ITEM_LOCATION, data };
}

export function showMessageModal() {
  return { type: ActionType.SHOW_APPLY_TO_ALL_STORE_MESSAGE_MODAL, showMessageModal: true };
};

export function hideMessageModal() {
  return { type: ActionType.SHOW_APPLY_TO_ALL_STORE_MESSAGE_MODAL, showMessageModal: false };
};

export function processingApplyToAllStore(){
  return { type: ActionType.PROCESSING_APPLY_TO_ALL_STORE, isProcessing: true };
}

export function doneProcessingApplyToAllStore(noOfItems, success){
  return { type: ActionType.PROCESSING_APPLY_TO_ALL_STORE, isProcessing: false, noOfItems, success };
}
  